import { format, getYear } from 'date-fns'
import { TFunction } from 'react-i18next'
import { getStatus } from '../../../../hooks/status'
import { questionarieServise } from '../../../../service/questionarie'
import { ScheduleService } from '../../../../service/schedule'
import { ScheduledById } from '../../../../service/schedule/response'
import { Constants } from '../../../../utils/constants'
import { httpFetch } from '../../../../utils/crud'
import { RequestErrors, Status } from '../../../../utils/enums'
import { Frequency } from '../../../../utils/enums/frequency'
import { handleAllErrors } from '../../../../utils/methods/handleErrors'
import { Color } from '../../../../utils/theme/types/color'
import { DataNotCreated, Item, ObjectGeneric } from '../../../../utils/types/generals'
import { isRequired, searchInModeLower } from '../../../../utils/validate/validate'
import { es } from 'date-fns/locale'
import { monthYear } from '../../../../utils/constants/date_month'
import { storeServices } from '../../../../utils/constants/callService'
import dayjs from 'dayjs'
import { Table } from '../../../users/pages/userType/types'
import { FrequencyEnum, FrequencyEnumTable, FrequencyEnumText, SerieEnumTextUper } from '../form/components/steps/configCalendar/enums'
import { DaysWeek, DaysWeekText } from '../../../reportFolio/pages/notifications/pages/main/utils/enums/tabs'
import { FrecuencyTypeTextResponse } from './enums/enums'

export const getList = async (colors: Color, t: TFunction<'translation', undefined>, body?: { query?: string; reloadItems?: boolean }, alreadyLoad?: boolean) => {
  const data = await ScheduleService(httpFetch).list({
    query: body?.query ?? 'size=20&page=1',
  })
  const totalPages = data.totalPages

  const getFrecuencyName = (type: FrecuencyTypeTextResponse) => {
    let text = '';
    switch (type) {
      case FrecuencyTypeTextResponse.CYCLICAL:
        text = SerieEnumTextUper.CYCLIC;
        break
      case FrecuencyTypeTextResponse.DAILY:
        text = SerieEnumTextUper.DAYLI;
        break
      case FrecuencyTypeTextResponse.WEEKLY:
        text = SerieEnumTextUper.WEEKLY;
        break
      case FrecuencyTypeTextResponse.UNIQUE:
        text = SerieEnumTextUper.UNIQUE;
        break
      default:
        text = ''
    }
    return text;
  }

  const getFrecuencyValue = (type: FrecuencyTypeTextResponse) => {
    let text: FrequencyEnumTable;
    switch (type) {
      case FrecuencyTypeTextResponse.CYCLICAL:
        text = FrequencyEnumTable.CYCLIC;
        break
      case FrecuencyTypeTextResponse.DAILY:
        text = FrequencyEnumTable.DAYLI;
        break
      case FrecuencyTypeTextResponse.WEEKLY:
        text = FrequencyEnumTable.WEEKLY;
        break
      case FrecuencyTypeTextResponse.UNIQUE:
        text = FrequencyEnumTable.UNIQUE;
        break
    }
    return text;
  }

  // let zoneIds: Item[] = []
  let keyCodeIds: Item[] = []

  let lastYear = 0
  let createYear: any[] = []

  const row: any[] = !data?.errors
    ? data?.items?.map((item) => {
      const store = item?.store
      const users = item?.userAssign

      if (!alreadyLoad || body?.reloadItems) {
        if (store?.keyCode && !keyCodeIds.some((item) => item?.value === store?.keyCode)) {
          keyCodeIds.push({
            label: `${store?.keyCode} - ${store?.name}`,
            value: store?.keyCode,
          })
        }
      }

      const month = format(new Date(item.createTime), 'LLLL', { locale: es })

      const currentYear = getYear(new Date(item.dateStart))

      if (currentYear > lastYear) lastYear = currentYear
      const isScheduleOpen = Boolean(Number(item?.openScheduled ?? 0))
      const timeZone = store?.timeZone ?? Constants.defaultTimeZone
      const startDate = item?.dateStartQuestionnaire ? dayjs(item?.dateStartQuestionnaire).tz(timeZone).format(Constants.dayjsFormat4) : null
      //item?.dateStart ? dayjs(item?.dateStart).tz(timeZone).format(Constants.dayjsFormat4) : null
      // item?.dateEnd ? dayjs(item?.dateEnd).tz(timeZone).format(Constants.dayjsFormat4) : null
      //itemQuestionnaire?.dateStart ? format(new Date(itemQuestionnaire?.dateStart), Constants.dateFormat2) : null
      const endDate = item?.dateEndQuestionnaire ? dayjs(item?.dateEndQuestionnaire).tz(timeZone).format(Constants.dayjsFormat4) : null

      return {
        id: item?.id,
        store_name: store?.name,
        idStore: store?.id,
        questionnaire: item.questionnaireName ?? '',
        store: `${store.keyCode ?? ''}${store.name ? ' - ' + store.name : ''}`,
        questionarieId: item.assingnedQuestionnaireId,
        frequencyType: !!item.frequencyType ? getFrecuencyName(item.frequencyType as FrecuencyTypeTextResponse) : 'N/A',
        frequencyTypeValue: !!item.frequencyType ? getFrecuencyValue(item.frequencyType as FrecuencyTypeTextResponse) : FrequencyEnumTable.FRRE,
        agent: !!item?.userAssign?.firstName || !!item?.userAssign?.lastName ? `${item?.userAssign?.firstName ?? ''} ${item?.userAssign?.lastName ?? ''}` : null,
        available_from: startDate,
        available_to: endDate,
        from: new Date(item?.dateStart).getTime(),
        to: new Date(item?.dateEnd).getTime(),
        status: getStatus(item?.statusIdQuestionnaire, colors, t),
        visitStatus: item?.status?.description,
        scheduleType: t(`schedule.scheduleTypes.${isScheduleOpen ? 'free' : 'programmed'}`),
        action: null,
        division: store.divisionName,
        unit: JSON.stringify({
          zone: store?.zoneName,
          store: `${store.keyCode ?? ''}${store.name ? ' - ' + store.name : ''}`,
          class: store?.className,
        }),
        reportUrl: item?.reportUrl,
        zone: store?.zoneName,
        class: store?.className,
        keyCode: store?.keyCode,
        cve: users?.division?.cveDivision,
        year: getYear(new Date(item.dateStart)),
        month: month ? month.charAt(0).toUpperCase() + month.slice(1) : 'N/A',
        weekYear: !!item?.weekYear ? `Semana ${item?.weekYear}` : null,
        country: 'México',
        state: store?.zipCode?.state,
        city: store?.zipCode?.country,
        userType: item?.userAssign?.userType?.name,
        curp: item?.userAssign?.curp,
        role: item?.userAssign?.role?.description,
        createById: item?.createdBy,
        serieId: item?.sequenceId,
        /* questionnaireArray: item?.assignedQuestionnaires?.map((itemQuestionnaire) => ({
          questionnaire: itemQuestionnaire?.questionnaireMain?.name,
          startDate: itemQuestionnaire?.dateStart ? format(new Date(itemQuestionnaire?.dateStart), Constants.dateFormat2) : null,
          area: itemQuestionnaire?.questionnaireMain?.area?.name,
          department: itemQuestionnaire?.questionnaireMain?.department?.name,
          startHour: itemQuestionnaire?.dateStart ? format(new Date(itemQuestionnaire?.dateStart), Constants.hourFormat) : null,
          endDate: itemQuestionnaire?.dateEnd ? format(new Date(itemQuestionnaire?.dateEnd), Constants.dateFormat2) : null,
          endHour: itemQuestionnaire?.dateEnd ? format(new Date(itemQuestionnaire?.dateEnd), Constants.hourFormat) : null,
          status: itemQuestionnaire?.status?.description,
        })), */
      }
    })
    : []

  while (true) {
    createYear.push({
      label: lastYear,
      value: lastYear,
    })
    lastYear--
    if (lastYear < 2022) break
  }

  return { row, keyCodeIds, createYear, monthYear, totalPages }
}

export const getStores = async ({ t, queary }: { t: TFunction<'translation', undefined>; queary?: string }) => {
  const data = await storeServices.getAllStoresWithAgents({ queary })
  const column: any[] = [
    {
      id: 'keyCode',
      label: t('general.tags.keyCode'),
      sortable: true,
      minWidth: 70,
    },
    {
      id: 'name',
      label: t('general.tags.store_name'),
      sortable: true,
      minWidth: 100,
    },
    {
      id: 'address',
      label: t('general.tags.address'),
      sortable: true,
      minWidth: 100,
    },
    {
      id: 'email',
      label: t('general.tags.email'),
      sortable: true,
      minWidth: 100,
    },
    {
      id: 'phone',
      label: t('general.tags.phone'),
      sortable: true,
      minWidth: 100,
    },
  ]
  const row: any[] = !data?.errors
    ? data
      ?.filter((item) => item?.statusId === Status.ACTIVE)
      ?.map((item) => {
        return {
          id: item?.id,
          name: item?.name,
          keyCode: item.keyCode,
          email: item?.email,
          phone: item?.phone,
          address: item?.address,
          storeTimeZone: item?.storeTimeZone
          // associatedAgents:
          //   item?.users?.map((agentItems) => ({
          //     fullName: `${agentItems.firstName} ${agentItems.lastName}`,
          //     curp: agentItems.curp,
          //     active: true,
          //     image: agentItems.picture,
          //     id: agentItems.id,
          //     role: agentItems.role
          //   })) ?? [],
        }
      })
    : []

  return { column, row }
}

export const getQuestionnarie = async (t: TFunction<'translation', undefined>) => {
  const data = await questionarieServise(httpFetch).getAllQuestionariesOld({ type: true })
  const column: any[] = [
    {
      id: 'quest_name',
      label: t('general.tags.quest_name'),
      sortable: true,
    },
    {
      id: 'ask',
      label: t('general.tags.ask'),
      sortable: true,
    },
    {
      id: 'action_plan',
      label: t('general.tags.action_plan'),
      sortable: true,
    },
    {
      id: 'app',
      label: t('general.tags.app'),
      sortable: true,
    },
  ]

  const row: any[] = !data.errors
    ? data?.map((item: any) => {
      let action_plan = item.actionPlanByItem
      if (item.actionPlanByItem === true || item.actionPlanByItem === false) action_plan = item.actionPlanByItem ? 'Por Item' : 'Por Cuestionario'

      return {
        id: item.id,
        quest_name: item.name,
        ask: item.countQuestions,
        action_plan: action_plan,
        app: item.countQuestionnaireVisit,
      }
    })
    : []

  return { column, row }
}

export const filterMain = (value: { [x: string]: any }, list: any[]): any[] => {
  const from = value.from?.valueOf()
  const to = value.to?.valueOf()

  const startFormat = new Date(from)?.setHours(0, 0, 0, 0)
  const endFormat = new Date(to)?.setHours(23, 59, 59, 999)
  return list?.filter((item) => {
    return (
      (from ? startFormat <= item.from : true) &&
      (to ? endFormat >= (item.from ? item.from : endFormat + 10000) : true) &&
      (value?.status instanceof Array ? (value?.status.length > 0 ? value?.status.find((e: any) => e.label == item.status.text) : true) : true) &&
      (value?.divisions instanceof Array ? (value?.divisions.length > 0 ? value?.divisions.find((e: any) => e.label == item.division) : true) : true) &&
      (value?.status?.value ? item?.status?.value === value?.status?.value : true) &&
      ((value?.search ? searchInModeLower(item?.store_name, value?.search) : true) ||
        (value?.search ? searchInModeLower(item?.division, value?.search) : true) ||
        (value?.search ? searchInModeLower(item?.zone, value?.search) : true) ||
        (value?.search ? searchInModeLower(item?.class, value?.search) : true) ||
        (value?.search ? searchInModeLower(item?.keyCode, value?.search) : true) ||
        (value?.search ? searchInModeLower(item?.agent, value?.search) : true) ||
        (value?.search ? searchInModeLower(item?.status?.text, value?.search) : true))
    )
  })
}
export const filterRow = (value: { [x: string]: any }, list: any[]) => {
  return list?.filter(
    (item) =>
      (value?.status ? item?.status?.value === value?.status : true) &&
      (searchInModeLower(item?.store_name, value?.search) ||
        searchInModeLower(item?.quest_name, value?.search) ||
        searchInModeLower(item?.name, value?.search) ||
        searchInModeLower(item?.id, value?.search) ||
        searchInModeLower(item?.email, value?.search) ||
        searchInModeLower(item?.phone, value?.search) ||
        searchInModeLower(item?.address, value?.search) ||
        searchInModeLower(item?.ask, value?.search) ||
        searchInModeLower(item?.app, value?.search) ||
        searchInModeLower(item?.action_plan, value?.search) ||
        searchInModeLower(item?.keyCode, value?.search) ||
        searchInModeLower(item?.agent, value?.search) ||
        // searchInModeLower(item?.available_from, value?.search) ||
        // searchInModeLower(item?.available_to, value?.search) ||
        searchInModeLower(item?.application_date, value?.search) ||
        searchInModeLower(item?.status?.text, value?.search))
  )
}

export const handleErrors = (values: any, t: any, ignore?: boolean) => {
  let error = {} as ObjectGeneric
  if (!values?.openQuestionnaire) {
    if (values?.frequency !== null) {
      if (isRequired(values?.frequency)) error.frequency = 'El campo frecuencia es requerido'
    }

    if (values?.every !== null) {
      if (isRequired(values?.every)) error.every = t('general.validations.required')
    }

    if (!ignore) {
      const fecha1 = dayjs(values?.from);
      const fecha2 = dayjs(values?.to);
      const diferenciaMinutos = fecha2.diff(fecha1, 'minute');

      const esMayorPorCincoMinutos = diferenciaMinutos >= 5
      // if (values?.from !== null) {
      //   if (isNaN(values?.from)) error.from = t('general.validations.startDate')
      //   else if (values?.from < Date.now()) error.from = t('general.validations.minimus0minute')
      // }

      if (values?.to !== null) {
        if (isNaN(values?.to)) error.to = t('general.validations.startDate')
        else if (!esMayorPorCincoMinutos) error.to = t('general.validations.minimus5minute')
      }
    }
  }

  return error
}

export const getDayText = (dayNumber: DaysWeek) => {
  let day: DaysWeekText = DaysWeekText.MONDAY

  switch (dayNumber) {
    case DaysWeek.MONDAY:
      day = DaysWeekText.MONDAY
      break
    case DaysWeek.TUESDAY:
      day = DaysWeekText.TUESDAY
      break
    case DaysWeek.WEDNESDAY:
      day = DaysWeekText.WEDNESDAY
      break
    case DaysWeek.THURSDAY:
      day = DaysWeekText.THURSDAY
      break
    case DaysWeek.FRIDAY:
      day = DaysWeekText.FRIDAY
      break
    case DaysWeek.SATURDAY:
      day = DaysWeekText.SATURDAY
      break
    case DaysWeek.SUNDAY:
      day = DaysWeekText.SUNDAY
      break
    default:
      day = DaysWeekText.MONDAY
  }

  return day;
}

export const getFrecuencyNameText = (frequency: FrequencyEnum) => {
  let text = '';
  switch (frequency) {
    case FrequencyEnum.CYCLIC:
      text = FrequencyEnumText.CYCLIC;
      break
    case FrequencyEnum.DAYLI:
      text = FrequencyEnumText.DAYLI;
      break
    case FrequencyEnum.UNIQUE:
      text = FrequencyEnumText.UNIQUE;
      break
    case FrequencyEnum.WEEKLY:
      text = FrequencyEnumText.WEEKLY;
      break
    default:
      text = ''
  }
  return text;
}

export const getDataByFrequency = (match: ObjectGeneric) => {
  let dateStart: string = '';
  let dateEnd: string = '';
  let every: string | null = null;
  let timeStart: string | null = null;
  let timeEnd: string | null = null;
  let frequency: FrequencyEnumText = FrequencyEnumText.UNIQUE;
  let duration: number | null = null;
  let days: number[] | null = null;
  const frequencyNumber: FrequencyEnum = match.frequency;

  if (frequencyNumber == FrequencyEnum.UNIQUE) {
    frequency = FrequencyEnumText.UNIQUE;
    dateStart = dayjs(match.from).format(Constants.dayjsFormat3);
    dateEnd = dayjs(match.to).format(Constants.dayjsFormat3);
  }

  if (frequencyNumber == FrequencyEnum.DAYLI) {
    frequency = FrequencyEnumText.DAYLI;
    dateStart = dayjs(match.fromDateDaily).format(Constants.dayjsFormat3);
    dateEnd = dayjs(match.toDateDaily).format(Constants.dayjsFormat3);
    timeStart = match.startDateDaily?.format(Constants.timeFormat);
    timeEnd = match.endDateDaily?.format(Constants.timeFormat);
    days = match.selectedDays?.map((num: number) => num === 7 ? 0 : num);
  }

  if (frequencyNumber == FrequencyEnum.WEEKLY) {
    frequency = FrequencyEnumText.WEEKLY;
    dateStart = dayjs(match.fromDateWeekly).format(Constants.dayjsFormat3);
    dateEnd = dayjs(match.toDateWeekly).format(Constants.dayjsFormat3);
    every = getDayText(match.dayOfWeek);
    timeStart = match.startDate?.format(Constants.timeFormat);
    timeEnd = match.endDate?.format(Constants.timeFormat);
    duration = Number(match.duration.match(/\d+/)?.[0]);
    days = match.selectedDays?.map((num: number) => num === 7 ? 0 : num);
  }

  if (frequencyNumber == FrequencyEnum.CYCLIC) {
    frequency = FrequencyEnumText.CYCLIC;
    dateStart = dayjs(match.fromDateCycli).format(Constants.dayjsFormat3);
    dateEnd = dayjs(match.toDateCycli).format(Constants.dayjsFormat3);
    timeStart = match.startDate?.format(Constants.timeFormat);
    timeEnd = match.endDate?.format(Constants.timeFormat);
    duration = Number(match.duration.match(/\d+/)?.[0]);
    days = match.selectedDays?.map((num: number) => num === 7 ? 0 : num);
  }

  //match.frequency
  return { dateStart, dateEnd, every, timeStart, timeEnd, frequency, duration, days }
}

export const submit = async ({ data, id, t }: { data: ObjectGeneric, t: TFunction<'translation', undefined>, id: number | undefined }) => {
  let snackbarBody = {
    open: false,
    type: '',
    message: '',
  }

  let response: ScheduledById
  if (id) {
    response = await ScheduleService(httpFetch).updateSchedule(data[0], id)
  } else {
    response = await ScheduleService(httpFetch).createSchedule(data)
  }

  if (response.errors) {
    snackbarBody = {
      open: true,
      type: 'error',
      message: handleAllErrors(response?.errors?.[0]?.code ?? '' as RequestErrors, t, `schedule.errors.${id ? 'updateError' : 'create'}`),
    }
  } else {
    snackbarBody = {
      open: true,
      type: 'success',
      message: t(`schedule.errors.${id ? 'updateSuccess' : 'success'}`),
    }
  }

  return {
    snackbarBody,
    response,
  }
}

export const disabled = (data: ObjectGeneric, agentAllChecketFalse: boolean) => {
  return !(!agentAllChecketFalse && data?.from && data?.to && data?.frequency && !(data?.frequency !== Frequency.DAILY && !data.every) && data?.to > data?.from)
}

export const listOfEErrors = ({ tableQuestionnarie, data, selected, detailAssigned }: {
  tableQuestionnarie: Table
  selected: {
    stores: number[];
    questionnaire: number[];
  }
  data: any
  detailAssigned: any
}) => {
  const questionnaires = detailAssigned?.questionnaire?.list || []
  let users: any[] = []
  detailAssigned?.stores?.list.forEach((e: any) => {
    users.push(...e.associatedAgents)
  })
  let selectedQuestionnaires = tableQuestionnarie?.row?.filter(questionnaireRow => selected?.questionnaire?.some(queestionnaireSelecteds => queestionnaireSelecteds == questionnaireRow.id))

  let usersByQuestionnaires: any[] = []
  let questionnairesduplicates: any[] = []
  let userSuccess: any[] = users
    ?.filter(user => !data?.some(userWithError => userWithError.userAssing == user.id))
    ?.map(user => ({
      userId: user.id,
      allSuccess: true,
    }))
  data.forEach((e1: any) => {
    const name = users.find((e2: any) => e2.id === e1.userAssing)
    const permissions = e1.questionnairesMainIdsPermission
    const duplicates = e1.questionnairesMainIdsDuplicate
    const allQuestions = [...new Set([...permissions, ...duplicates])];
    let questionnairesWithError: any[] = []
    let questionnairesduplicated: any[] = []
    let userCanUseThisQuestionnaires: Item[] = selectedQuestionnaires.filter(selecteds => !allQuestions.some((permission: number) => permission == selecteds.id))

    permissions.forEach((id: any) => {
      const name = questionnaires.find((e: any) => e.id === id)?.title
      questionnairesWithError.push(name)
    })
    duplicates.forEach((id: any) => {
      const name = questionnaires.find((e: any) => e.id === id)?.title
      questionnairesduplicated.push(name)
    })

    usersByQuestionnaires.push({
      user: name?.fullName,
      useerId: name?.id,
      questionnaires: questionnairesWithError,
      userCanUseThisQuestionnaires
    })
    questionnairesduplicates.push({
      user: name?.fullName,
      useerId: name?.id,
      questionnaires: questionnairesduplicated,
    })
  })
  return { usersByQuestionnaires, questionnairesduplicates, userSuccess }
}

export const errorsToStores = ({ data }: { data?: DataNotCreated[] }) => {
  let body: Record<string, string[]> = {}
  if (!data) return { body }

  for (const error of data) {
    const questionnaireId = Array
      .from(new Set([
        ...error.questionnairesMainIdsPermission ?? [],
        ...error.questionnairesMainIdsDuplicate ?? [],
        ...error.questionnaireMainId ?? []
      ]))
    const id = `${error.storeId}-${error.userAssing}-${questionnaireId[0]}`
    body = {
      ...body,
      [id]: error?.errors?.map(
        (itemErrors) => itemErrors.code
      ) || []
    }
  }

  return { body }
}